
import BaseComponent from '../abstracts/BaseComponent';
import { DataLayerUtils } from '../utilities/DataLayer';

export default class DataLayerComponent extends BaseComponent {
  constructor(element) {
    super(element);
    const event = this.$options.event || 'click';

    this.observeAction(event);
  }

  observeAction(event) {
    this.$on(`${event}.datalayer`, (e) => {
      let dlobj = JSON.parse(JSON.stringify(this.$options.object));
      // hack per aggiungere la posizione nell'elenco prodotti PDB-127
      let _this = this._componentElement;
      let idx = Array.prototype.slice.call(document.querySelectorAll('.product-tile, .product-tile-big')).indexOf(_this) + 1;
      if (dlobj.event === 'productClick' && dlobj.ecommerce.click.products) {
        dlobj.ecommerce.click.products[0].position = idx;
      }
      // fine hack
      this.push(dlobj);
    });
  }

  push(obj) {
    return DataLayerUtils.push(obj);
  }
}
